<i18n>
{
  "ru": {
    "searchPlaceholder": "Поиск..."
  },
  "uk": {
    "searchPlaceholder": "Пошук..."
  }
}
</i18n>

<template>
  <form
    class="as-search form-inline my-2 my-lg-0 col-md-6 npd"
    name="search"
    method="POST"
  >
    <div class="as-search-wrapper">
      <input
        class="form-control mr-sm-2 col-11"
        type="search"
        :placeholder="$t('searchPlaceholder')"
        name="query"
      />
      <button class="btn btn-primary my-2 my-sm-0 col-1" type="submit">
        <font-awesome-icon icon="search" />
      </button>
      <div class="search-info-block">
        <div class="row" style="margin:0;">
          <div class="search-response col-12">
            <ul>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
              <li>
                <a href="#">Вариант подсказки</a>
              </li>
            </ul>
          </div>
          <div class="search-filter col-12 npd">
            <div class="row" style="margin:0;">
              <div class="col-9 npd">
                <div class="search-filter-body">
                  <form class="form-inline">
                    <select class="custom-select my-2 mr-sm-2">
                      <option selected>Бренды</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <select class="custom-select my-2 mr-sm-2">
                      <option selected>Тип обуви</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                    <select class="custom-select my-2 mr-sm-2">
                      <option selected>Фильтр 2</option>
                      <option value="1">One</option>
                      <option value="2">Two</option>
                      <option value="3">Three</option>
                    </select>
                  </form>
                </div>
              </div>
              <div class="col-3 npd">
                <div class="search-filter-btn">
                  <button class="btn btn-get-filter">Подробнее</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {};
</script>
